addFontModuleSettings = angular.module('editor.fontSettings.controller', ["services"])

addFontModuleSettings.controller "fontSettingsCtrl", ["$scope", "$rootScope", "$state", "Font", "Site", "LmsPage", "Section", "$timeout", "layoutEditor", ($scope, $rootScope, $state, Font, Site, LmsPage, Section, $timeout, layoutEditor) ->

  if !$rootScope.site_fonts and $rootScope.site
    $rootScope.site_fonts = {id: $rootScope.site.id, default_font: $rootScope.site.default_font, h_font: $rootScope.site.h_font}

  String::replaceAll = (search, replacement) ->
    target = this
    target.replace new RegExp(search, 'g'), replacement

  $scope.fontSettings = {}

  destroyFontsNames = $rootScope.$on "fontNames:loaded", ->
    Font.connectFonts Editor.Instrumentations.fonts

  destroySectionFonts = $rootScope.$on "sectionFonts:loaded", (e, fonts) ->
    Font.connectFonts fonts

  $scope.$on "$destroy", ->
    destroyFontsNames()
    destroySectionFonts()

  reBuildCKEFontList = ->
    _.each CKEDITOR.instances, (instance, id) ->
      instance.ui.instances.FontFamily.buildList()

  removeFontStylesCKE = (font) ->
    _.each CKEDITOR.instances, (instance, id) ->
      angular.element("##{id}").find("span").each (index, span) ->
        spanFamily = $(span).css("font-family").toLowerCase().replaceAll("'", "")
        fontFamily = font.family.toLowerCase()
        if spanFamily is fontFamily
          $(span).css "font-family", ""

  $scope.searchFonts = (value) ->
    result = []
    _.each $scope.GFonts, (font) ->
      family = font.family.toLowerCase()
      index = family.indexOf value.toLowerCase()
      if index > -1
        result.push font
    result

  $scope.setFont = (font, model, label, attr) ->
    Font.connectFont font
    $scope[attr] = font

  $scope.GFonts = []

  $scope.destroyFonts = ->
    $scope.GFonts = []

  # Успешная загрузка коллекции шрифтов

  GFontsSuccess = (gFonts) ->
    result = []
    $scope.GFonts = _.each gFonts.items, (item) ->
      if "cyrillic" in item.subsets
        result.push item
    $scope.GFonts = _.union result, $scope.GFonts
    $scope.fontsLoading = false

  # Запрос шрифтов

  $scope.getGoogleFonts = ->
    return false if $scope.GFonts.length > 0
    $scope.fontsLoading = true
    Font.getAll().then GFontsSuccess

  $scope.$on "destroy", ->
    log "destroy"
    $scope.GFonts = []

  # Представляем subsets, variants как массив

  fontSettingsToArray = (type) ->
    result = []
    for key of $scope.fontSettings[type]
      if $scope.fontSettings[type][key]
        result.push key
    result

  $scope.connectFont = (font) ->
    Font.connectFont font
    $scope.fontName = ""

  # Пушим шрифт в массив дополнительных шрифтов

  addFontToEditor = (font) ->
    $rootScope.Editor.Instrumentations.fonts.push font
    reBuildCKEFontList()
    Editor = $rootScope.Editor
    $scope.selectedFont = {}
    $scope.fontSettings = {}

  updateFontsSuccess = (fontData) ->
    font = fontData.fonts_attributes[fontData.fonts_attributes.length-1]
    Font.connectFont font
    addFontToEditor font
    $scope.adding = false

  # Сохраняем установленные шрифты в БД

  updateFonts = (font) ->
    $scope.adding = true
    if Editor.mode is "site.page.editor"
      Site.updateByRoute({fonts_attributes: [font]}).then updateFontsSuccess
    if Editor.mode is "lesson.page.editor"
      LmsPage.updateByRoute({fonts_attributes: [font]}).then updateFontsSuccess
    if Editor.mode is "editor.section"
      data =
        fonts_attributes: [font]
        id: $state.params.sectionId
      Section.savePublic(data).then updateFontsSuccess

  # Функция кнопки добавить шрифт

  $scope.addFont = (selectedFont) ->
    font = {}
    $scope.selectedFont = selectedFont
    font.family = selectedFont.family
    font.variants = fontSettingsToArray "variants"
    font.subsets = fontSettingsToArray "subsets"
    fontExist = _.filter($rootScope.Editor.Instrumentations.fonts, {family: selectedFont.family})
    if fontExist.length is 0
      updateFonts font


  $scope.customAddFont = (selectedFont, attr, variants_attr) ->
    font = {}
    $scope[attr] = selectedFont
    font.family = selectedFont.family
    font["variants"] = fontSettingsToArray variants_attr
    font.subsets = fontSettingsToArray "subsets"
    fontExist = _.filter($rootScope.Editor.Instrumentations.fonts, {family: selectedFont.family})
    if fontExist.length is 0
      updateFonts font

  clearFontsInEditorView = (default_font, default_h) ->
    $('#tpl-wrapper *').filter ->
      if $(this).attr("style")
        if $(this).attr('style').indexOf('font-family') > -1
          $(this).css {fontFamily: ""}
      if $(this).prop("tagName") is "FONT"
        $(this).removeAttr "face"

    layoutEditor.setFontToJsonWidgets $rootScope.Y, {default: default_font, h: default_h}

  # Функция кнопки применить h1-h6 шрифт

  $scope.setHFont = (selectedFont) ->
    selectedFont = angular.copy selectedFont
    $scope.customAddFont selectedFont, 'selectedHFont', "h_variants"
    $rootScope.site_fonts.h_font = selectedFont
    $("#fontStyles").html($("#fontStyles").html()+ "h1,h2,h3,h4,h5,h6 {font-family: #{selectedFont.family}}")
    clearFontsInEditorView $rootScope.site_fonts.default_font.family, $rootScope.site_fonts.h_font.family
    $rootScope.defaultFontSetted = true

  # Функция кнопки применить основной  шрифт

  $scope.setDefaultFont = (selectedFont) ->
    selectedFont = angular.copy selectedFont
    $scope.customAddFont selectedFont, 'selectedDefaultFont', "default_variants"
    $rootScope.site_fonts.default_font = selectedFont
    $("#fontStyles").html($("#fontStyles").html()+ ".str-wrapper {font-family: #{selectedFont.family}} .str-wrapper .strwf_button {font-family: #{selectedFont.family}}")
    clearFontsInEditorView $rootScope.site_fonts.default_font.family, $rootScope.site_fonts.h_font.family
    $rootScope.defaultFontSetted = true
    return

  # Удаление шрифта из массива шрифтов секции

  removeFontFromEditor = (font) ->
    find = _.filter $rootScope.Editor.Instrumentations.fonts, family: font.family
    index = $rootScope.Editor.Instrumentations.fonts.indexOf find[0]
    if index > -1
      $rootScope.Editor.Instrumentations.fonts.splice index, 1
    Editor = $rootScope.Editor
    reBuildCKEFontList()
    removeFontStylesCKE font

  $scope.removeHFont = (font) ->
    font = angular.copy font
    if font
      font.family = ""
      font.variants = []
      font.subsets = []
    $rootScope.site_fonts.h_font = {}
    $rootScope.defaultFontSetted = true
    $("#fontStyles").html($("#fontStyles").html()+ "h1,h2,h3,h4,h5,h6 {font-family: Open Sans}")
    clearFontsInEditorView $rootScope.site_fonts.default_font.family, $rootScope.site_fonts.h_font.family
    return

    # Site.update($rootScope.site_fonts).then ->
      # $rootScope.$broadcast "get:styles"

  $scope.removeDefaultFont = (font) ->
    font = angular.copy font
    if font
      font.family = ""
      font.variants = []
      font.subsets = []
    $rootScope.site_fonts.default_font = {}
    $rootScope.defaultFontSetted = true
    $("#fontStyles").html($("#fontStyles").html()+ ".str-wrapper {font-family: Open Sans} .strwf_button {font-family: Open Sans}")
    clearFontsInEditorView $rootScope.site_fonts.default_font.family, $rootScope.site_fonts.h_font.family
    return

    # Site.update($rootScope.site_fonts).then ->
    #   $rootScope.$broadcast "get:styles"

  removeFont = (font) ->
    font._destroy = true
    font = angular.copy font
    if Editor.mode is "site.page.editor"
      Site.updateByRoute({fonts_attributes: [font]}).then ->
        removeFontFromEditor font
    if Editor.mode is "lesson.page.editor"
      LmsPage.updateByRoute({fonts_attributes: [font]}).then ->
        removeFontFromEditor font
    if Editor.mode is "editor.section"
      data =
        fonts_attributes: [font]
        id: $state.params.sectionId
      Section.savePublic(data).then ->
        removeFontFromEditor font

  # Функция кнопки удаления шрифта
  $scope.removeFont = (font) ->
    if $rootScope.site_fonts.default_font and font.family is $rootScope.site_fonts.default_font.family
      $scope.removeDefaultFont(font)
    else if $rootScope.site_fonts.h_font and font.family is $rootScope.site_fonts.h_font.family
      $scope.removeHFont(font)

    removeFont(font)

]



// WEBPACK FOOTER //
// ./src/app/editor/font_settings/fontSettings.controller.coffee